/** Matches the regular message bubble max-width utility used by Message.jsx. */
export const MESSAGE_BUBBLE_MAX_WIDTH_PX = 520;

/** Matches `richdown-bubble--base` horizontal `px-3.5` padding. */
export const MESSAGE_BUBBLE_HORIZONTAL_PADDING_PX = 28;

const MESSAGE_ROW_OUTER_HORIZONTAL_PADDING_PX = 32;
const MESSAGE_ROW_MAX_WIDTH_PX = 672;
const MESSAGE_ROW_CONTENT_LEFT_PADDING_PX = 22;
const MESSAGE_AUTHOR_GUTTER_PX = 48;

/** Returns a static Tailwind class so the renderer and estimator share the same cap. */
export function getMessageBubbleMaxWidthClassName(): string {
  return 'max-w-[520px]';
}

/** Resolves the text box width inside the responsive message row and regular bubble. */
export function resolveMessageTextContentWidth(scrollerWidth: number): number {
  assertFinitePositive(scrollerWidth, 'scrollerWidth');

  // MessageListItem: `px-4`, then `max-w-2xl pl-2`; Message: `ml-12`.
  const rowWidth = Math.min(
    MESSAGE_ROW_MAX_WIDTH_PX,
    Math.max(1, scrollerWidth - MESSAGE_ROW_OUTER_HORIZONTAL_PADDING_PX)
  );
  const availableBubbleWidth = Math.max(
    1,
    rowWidth - MESSAGE_ROW_CONTENT_LEFT_PADDING_PX - MESSAGE_AUTHOR_GUTTER_PX
  );
  const bubbleWidth = Math.min(availableBubbleWidth, MESSAGE_BUBBLE_MAX_WIDTH_PX);

  return Math.max(1, bubbleWidth - MESSAGE_BUBBLE_HORIZONTAL_PADDING_PX);
}

function assertFinitePositive(value: number, name: string): void {
  if (!Number.isFinite(value) || value <= 0) {
    throw new Error(`${name} must be a finite positive number`);
  }
}
